import { clamp } from "lodash-es";
import uuidv4 from "../../../../lib/utils/uuidv4";
import TabsList from "./TabsList";
import { tabsContainerMixin } from "../../../../lib/helpers";
import "./index.css";
export default {
  name: 'WTabs',
  mixins: [tabsContainerMixin],
  props: {
    cur: {
      type: Number,
      default: 0
    },
    titleCss: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'cur',
    event: 'select'
  },
  data() {
    return {
      current: this.cur,
      allTabs: [],
      // TabPane 组件实例
      uuid: uuidv4()
    };
  },
  provide() {
    return {
      'uicore:WTabs': this
    };
  },
  watch: {
    cur(val) {
      this.current = val;
    }
  },
  methods: {
    setCurrent(newIndex) {
      var _this$$refs;
      this.current = newIndex;
      this.$emit('select', newIndex);
      this.$emit('uc:report', {
        event: 'select',
        eid: (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.tabList) === null || _this$$refs === void 0 ? void 0 : _this$$refs.getTabTitle(newIndex),
        $event: newIndex
      });
    }
  },
  render() {
    var _this$$slots$default, _this$$slots$default$;
    const h = arguments[0];
    /** @type {Vue.VNode[]} */
    const children = [];
    let index = -1;
    (_this$$slots$default = this.$slots.default) === null || _this$$slots$default === void 0 || (_this$$slots$default$ = _this$$slots$default.forEach) === null || _this$$slots$default$ === void 0 || _this$$slots$default$.call(_this$$slots$default, /** @param {Vue.VNode} item */item => {
      if (item && !item.isComment) {
        var _item$componentOption;
        index += 1;
        const propsData = (_item$componentOption = item.componentOptions) === null || _item$componentOption === void 0 ? void 0 : _item$componentOption.propsData;
        if (propsData && propsData.ucPresetIndex !== index) {
          propsData.ucPresetIndex = index;
        }
      }
      children.push(item);
    });
    const {
      uuid
    } = this;
    const current = clamp(this.current, 0, children.length - 1);
    const specialCSS = `.uc-tabs[data-uc-tabs-uuid="${uuid}"] > .uc-tabs-content-wrap > .uc-tabs-content:not(:nth-child(${current + 1})) { display: none }`;
    return h("div", {
      "class": "uc-tabs w-tabs",
      "attrs": {
        "data-uc-tabs-uuid": uuid
      }
    }, [h(TabsList, {
      "ref": "tabList",
      "key": "tabList",
      "attrs": {
        "tabs": this.allTabs,
        "current": current
      },
      "on": {
        "goto": this.setCurrent
      },
      "style": this.titleCss
    }), h("div", {
      "class": "uc-tabs-content-wrap",
      "style": true
    }, [children]), h("style", {
      "key": "specialCSS"
    }, [specialCSS])]);
  }
};
//# sourceMappingURL=index.js.map
